/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { dlsBrightBlue, IconWarning } from '@americanexpress/dls-react';
import merge from 'deepmerge';
import errorComponentStyle from '../../styles/ErrorHandling/ErrorComponentStyle';

export const ErrorComponent = (props) => {
  const {
    title = 'We\'re unable to load this page at this time',
    content = 'Please try again after sometime.',
    theme,
  } = props;

  const styleObj = merge.all([errorComponentStyle, theme || {}]);

  return (
    <div id="error-container" css={styleObj['.errorContainer']}>
      <div id="error-icon-container">
        <IconWarning id="error-icon-warning" size="xl" theme={dlsBrightBlue} />
      </div>
      <div id="error-title-container" css={styleObj['.headingMessage']}>
        <h3 id="error-title" className="heading-4 ls-accent-gray-05">{title} </h3>
      </div>
      <div id="error-heading" css={styleObj['.subHeading']}>{content}</div>
    </div>
  );
};

ErrorComponent.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  theme: PropTypes.shape,
};
